"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HeaderMaker_1 = __importDefault(require("containers/TableMaker/HeaderMaker"));
var RowMaker_1 = __importDefault(require("containers/TableMaker/RowMaker"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var selectors_1 = require("../selectors");
var tableConf_1 = require("../tableConf");
var Header = (0, HeaderMaker_1.default)(tableConf_1.activeUsersTableConf);
var Row = (0, RowMaker_1.default)(tableConf_1.activeUsersTableConf);
var ActiveUsers = function () {
    var companyUsers = (0, react_redux_1.useSelector)(selectors_1.selectPopulatedActiveUsers);
    var sortedCompanyUsers = (0, hooks_1.useSortArray)(companyUsers, tableConf_1.activeUsersTableConf.extractors);
    if (!(0, react_redux_firebase_1.isLoaded)(sortedCompanyUsers)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    if ((0, react_redux_firebase_1.isEmpty)(sortedCompanyUsers)) {
        return (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3, align: "center" }, { children: "No users found" }));
    }
    return ((0, jsx_runtime_1.jsxs)(Table_1.default, { children: [(0, jsx_runtime_1.jsx)(Header, {}), (0, jsx_runtime_1.jsx)(TableBody_1.default, { children: sortedCompanyUsers === null || sortedCompanyUsers === void 0 ? void 0 : sortedCompanyUsers.map(function (user) { return (0, jsx_runtime_1.jsx)(Row, { item: user }, user.id); }) })] }));
};
exports.default = (0, SortHoC_1.default)(ActiveUsers, { key: 'name', order: 1 });
